import { bl_alg_cc_qc_field_values_hdr_RowClass as bl_alg_cc_qc_field_values_hdr_RowClass} from "../../../../dbschema/bl_alg_cc_qc_field_values_hdr.model";
import { BaseContainerModel } from "../../../base-container.model";

//this is for answer of qc_hdr
export class QualityControlFieldValuesHdrContainerModel extends BaseContainerModel {
	bl_alg_cc_qc_field_values_hdr: bl_alg_cc_qc_field_values_hdr_RowClass =
		new bl_alg_cc_qc_field_values_hdr_RowClass();
}